import { useCallback, useMemo } from 'react';

import { SupportedCurrency } from '__generated__/globalTypes';
import { useCurrentUserContext } from 'contexts/currentUser';
import { AcceptedCurrenciesValue } from 'hooks/useAcceptedCurrencies';
import { useCurrentUserAcceptedCurrencies } from 'hooks/useCurrentUserAcceptedCurrencies';
import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';

export const useReferenceCurrencyForSale = () => {
  const {
    fiatCurrency: { code },
    walletPreferences: { onlyShowFiatCurrency, enabledWallets },
  } = useCurrentUserContext();

  const { acceptedCurrencies } = useCurrentUserAcceptedCurrencies();
  const {
    update: storeReferenceCurrencyForSale,
    loading,
    lifecycle,
  } = useLifecycle();

  const update = useCallback(
    (value: SupportedCurrency) => {
      storeReferenceCurrencyForSale(LIFECYCLE.referenceCurrencyForSale, value);
    },
    [storeReferenceCurrencyForSale]
  );
  const referenceCurrencyForSale = useMemo(() => {
    if (!enabledWallets) return SupportedCurrency.WEI;
    if (onlyShowFiatCurrency) return code;
    switch (acceptedCurrencies) {
      case AcceptedCurrenciesValue.FIAT:
        return code;
      case AcceptedCurrenciesValue.ETH:
        return SupportedCurrency.WEI;
      case AcceptedCurrenciesValue.BOTH:
        return lifecycle?.referenceCurrencyForSale || code;
      default:
    }
    return code;
  }, [
    enabledWallets,
    onlyShowFiatCurrency,
    code,
    acceptedCurrencies,
    lifecycle?.referenceCurrencyForSale,
  ]);

  return {
    update,
    loading,
    referenceCurrencyForSale,
  };
};
